// allReducer.js
const initialState = {
  userListItem: null,
  memberList: [], // Default value
  // selectedMemberList: [],
  serviceList: [],
  serviceListItem: null,
  assignList: [],
  managerList: [],
  supervisorList: [],
  districtList: [],
  // usernameError: false,
  // usernameErrorMessage: '',
  // passwordError: false,
  // passwordErrorMessage: '',
  // username: '',
  // password: '',
  // loading4SignIn: false,
  // credential: '',
  displayMode: 1,  
  serviceOptionList: [],
  serviceOptionListItem: null,
};

export default function allReducer(state = initialState, action) {
  switch (action.type) {
    case 'setUserListItem':
      return {
        ...state,
        userListItem: action.payload,
      };        
    case 'setServiceOptionListItem':
      return {
        ...state,
        serviceOptionListItem: action.payload,
      };      
    case 'setServiceOptionList':
      return {
        ...state,
        serviceOptionList: action.payload,
      };     
    case 'setDisplayMode':
      return {
        ...state,
        displayMode: action.payload,
      };      
    // case 'setUsernameError':
    //   return {
    //     ...state,
    //     usernameError: action.payload,
    //   };
    // case 'setUsernameErrorMessage':
    //   return {
    //     ...state,
    //     usernameErrorMessage: action.payload,
    //   };     
    // case 'setPasswordError':
    //   return {
    //     ...state,
    //     passwordError: action.payload,
    //   };  
    // case 'setPasswordErrorMessage':
    //   return {
    //     ...state,
    //     passwordErrorMessage: action.payload,
    //   };  
    // case 'setPassword':
    //   return {
    //     ...state,
    //     password: action.payload, // Update the selected book
    //   };       
    // case 'setUsername':
    //   return {
    //     ...state,
    //     username: action.payload, // Update the selected book
    //   }; 

    case 'setDistrictList':
      return {
        ...state,
        districtList: action.payload, // Update the selected book
      };     
    case 'setSupervisorList':
      return {
        ...state,
        supervisorList: action.payload, // Update the selected book
      };     
    case 'setManagerList':
      return {
        ...state,
        managerList: action.payload, // Update the selected book
      };    
    case 'setMemberList':
      return {
        ...state,
        memberList: action.payload, // Update the selected book
      };
    // case 'setSelectedMemberList':
    //   return {
    //     ...state,
    //     selectedMemberList: action.payload, // Update the selected book
    //   };  
    case 'setServiceListItem':
      return {
        ...state,
        serviceListItem: action.payload, // Update the selected book
      };      
    case 'setServiceList':
      return {
        ...state,
        serviceList: action.payload, // Update the selected book
      };     
    case 'setAssignList':
      return {
        ...state,
        assignList: action.payload, // Update the selected book
      };            
    case 'reset4All':
      return initialState;     
    default:
      return state;
  }
}
// export const setCredential = (e) => ({
//   type: 'setCredential',
//   payload: e,
// });

// export const setUsernameError = (e) => ({
//   type: 'setUsernameError',
//   payload: e,
// });

// export const setUsernameErrorMessage = (e) => ({
//   type: 'setUsernameErrorMessage',
//   payload: e,
// });

// export const setPasswordError  = (e) => ({
//   type: 'setPasswordError',
//   payload: e,
// });

// export const setPasswordErrorMessage  = (e) => ({
//   type: 'setPasswordErrorMessage',
//   payload: e,
// });

// export const setPassword = (e) => ({
//   type: 'setPassword',
//   payload: e,
// });

// export const setUsername = (e) => ({
//   type: 'setUsername',
//   payload: e,
// });
//setServiceOptionListItem

export const setUserListItem = (e) => ({
  type: 'setUserListItem',
  payload: e,
});

export const setServiceOptionListItem = (e) => ({
  type: 'setServiceOptionListItem',
  payload: e,
});

export const setServiceOptionList = (e) => ({
  type: 'setServiceOptionList',
  payload: e,
});

export const setDisplayMode = (e) => ({
  type: 'setDisplayMode',
  payload: e,
});

export const setDistrictList = (e) => ({
  type: 'setDistrictList',
  payload: e,
});

export const setSupervisorList = (e) => ({
  type: 'setSupervisorList',
  payload: e,
});

export const setManagerList = (e) => ({
  type: 'setManagerList',
  payload: e,
});

export const setMemberList = (e) => ({
  type: 'setMemberList',
  payload: e,
});

// export const setSelectedMemberList = (e) => ({
//   type: 'setSelectedMemberList',
//   payload: e,
// });

export const setServiceListItem = (e) => ({
  type: 'setServiceListItem',
  payload: e,
});

export const setServiceList = (e) => ({
  type: 'setServiceList',
  payload: e,
});

export const setAssignList = (e) => ({
  type: 'setAssignList',
  payload: e,
});

export const reset4All  = (e) => ({
  type: 'reset4All',
  payload: e,
});